import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { Combo2Service } from "../../../services/index";
import { POCancelService } from "../../../services/poCancel.service";

@Component({
  selector: "addEditPOCancel",
  templateUrl: "./addEditPOCancel.html",
})
export class AddEditPOCancel {
  @Output() tabUpdateEvent = new EventEmitter();
  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.pocanceldata = designdata;
    if (this.mode == "Edit") {
      this.getDesignList(this.pocanceldata["pc_id"]);
      this.onSelectPono(this.pocanceldata["po_id"]);
      this.pocanceldata.cancel_date = designdata.cancel_date;
    }
  }

  get params(): any[] {
    return this._params;
  }

  row: any;
  data: any;
  designdata: any = { indent_no: [], fin_id: 3 };
  pocanceldata: any = {
    fin_id: 3,
    cancel_date: new Date(),
    po_no: "",
    po_id: "",
  };
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  finyearList: any;
  mode: string;
  saveEvent: any;
  agentList: any;
  ponoList: any;
  partyCodeList: any;
  designList = [
    {
      pdesign_no: "",
      pcolor: "",
      mtrs: 0,
      can_mtr: 0,
    },
  ];
  designnoList = [];
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @ViewChild("widthAuto") widthAuto;
  poCtrl: FormControl = new FormControl();
  indentControl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private combo: Combo2Service,
    private poservice: POCancelService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      quality: "",
      type: "",
      color: "",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      designList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.designList.push(row);
  }
  page_id: string = Math.random().toString(36).substr(2, 9) + "_";
  ngOnInit() {
    this.finyearCombo();
    this.poList();
    if (this.mode == "Add") {
      this.pocanceldata.cancel_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.getAuto();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + this.page_id + "date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    $("#" + this.page_id + nextEl).focus();

    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
  }

  getDesignList(id) {
    let params = {
      pc_id: id,
    };
    this.poservice.getDesignList(params).then((res: any) => {
      this.designList = res.data;
    });
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design = this.designList[ind]["design_no"],
      qtyval = this.designList[ind]["qty"],
      amount = this.designList[ind]["amt"],
      gst = this.designList[ind]["gst"],
      gstamt = this.designList[ind]["gstamt"],
      qty = this.designList[ind]["qty"],
      rateval = this.designList[ind]["rate"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "design" && nxtRow.length == 0) {
      let len = this.designList.length;
      let pdesign_no = this.designList[len - 1]["pdesign_no"];
      let mtrs = this.designList[len - 1]["can_mtr"];

      if (pdesign_no != "" && mtrs > 0) {
        this.designList.push({
          pdesign_no: "",
          pcolor: "",
          mtrs: 0,
          can_mtr: 0,
        });

        $("#" + this.page_id + "design").focus();
      } else {
        //$('#' + this.page_id + 'totalamt' ).focus();
        setTimeout(() => {
          $("#" + this.page_id + "design").focus();
        }, 100);
        return false;
      }

      nxtInd = this.designList.length - 1;
    } else if (fld == "item_name") {
      let nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    }

    setTimeout(() => {
      $("#" + this.page_id + fld + "-" + nxtInd).focus();
    }, 100);
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    this.poservice.getAuto({}).then((res: any) => {
      this.pocanceldata.pc_no = res;
    });
  }

  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }

  poList() {
    this.poservice.polist({}).then((res: any) => {
      this.ponoList = res.data;
      if (this.mode == "Edit") {
        this.poCtrl.setValue(this.pocanceldata.po_id);
      }
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id + "" });
      if (!fitem) {
      }

      return fitem["finyear"];
    }
    return "";
  }
  displayPOno(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Pono") {
      list = this.ponoList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { po_id: id });
      return fitem["po_no"];
    }
    return "";
  }

  onSelectPono(po_id) {
    let params = {
      po_id: po_id,
    };
    this.poservice.getIndentno(params).then((res: any) => {
      this.designnoList = res.data;
      this.pocanceldata.po_no = res.data[0].po_no;
      this.pocanceldata.indent_no = res.data[0].indent_no;
      this.pocanceldata.indent_list = this.pocanceldata.indent_no.split(",");
    });
  }

  cancelIndentCheck(no) {
    let num = no.toString();
    let arrInd = this.pocanceldata.indent_list;
    if (arrInd == undefined) {
      if (this.pocanceldata.can_indent_no == this.pocanceldata.indent_no) {
        this.pocanceldata.can_indent_no = num;
      } else {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Enter correct indent no",
          timeout: 1000,
        });
      }
    } else {
      if (arrInd.indexOf(num) >= 0) {
        this.pocanceldata.can_indent_no = num;
      } else {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Enter correct indent no",
          timeout: 1000,
        });
      }
    }
  }

  cancelMtrsCheck(can_mtrs, ind) {
    let mtr = this.designList[ind].mtrs;
    let canmtrs = 0;

    if (can_mtrs > mtr) {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "Cancel mtr should be less than ordered mtrs",
        timeout: 2000,
      });
      this.designList[ind].can_mtr = 0;
    }
  }

  onSelectItem($event, item, ind) {
    if (this.pocanceldata.po_no == undefined || this.pocanceldata.po_id == "") {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "Please Enter Po.no",
        timeout: 2000,
      });
    } else {
      this.getcolorlist(item, ind);
    }
  }

  getcolorlist(design, ind) {
    let params = {
      design_no: design.pdesign_no,
    };
    this.poservice.getColorList(params).then((res: any) => {
      if (res.data.length == 0) {
        this.designList[ind].mtrs = this.designnoList[ind].mtrs;
      } else {
        this.colorList = res.data;
      }
    });
  }

  onSelectColor($event, color, ind) {
    this.designList[ind].mtrs = color.mtrs;

    this.onGoToNextFld($event, "mtr", ind);
  }

  oncheckemptyrow() {
    let design = this.designList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i]["pdesign_no"] != "") {
        desList.push(design[i]);
      }
    }
    this.designList = desList;
    this.onSaveOrder();
  }

  onSaveOrder(): void {
    let params: any = Object.assign({}, this.pocanceldata);
    params["tabevent"] = undefined;
    params["cancel_date"] = this.datePipe.transform(
      params["cancel_date"],
      "yyyy-MM-dd"
    );
    params["designList"] = JSON.stringify(this.designList);
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.poservice
        .saveOrder(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  onClickCode(party_code) {
    let partyCodeList = _.filter(this.codeList, { code: party_code });
    this.partyCodeList = partyCodeList;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/poCancel/addEditPOCancel.ts